/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Mode_HtmlInputs */

const cs_builder_mode_html = /** @type {(inputs: Builder_Mode_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokument`)
};

const en_builder_mode_html = /** @type {(inputs: Builder_Mode_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

/**
* | output |
* | --- |
* | "Document" |
*
* @param {Builder_Mode_HtmlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_mode_html = /** @type {((inputs?: Builder_Mode_HtmlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Mode_HtmlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_mode_html(inputs)
	return cs_builder_mode_html(inputs)
});